import { httpPost } from "./httpService";

export function listRelationshipCategories(knowledgeGraphId, keywords) {
  return httpPost("/admin/relationshipCategory/v1/list", {
    knowledgeGraphId,
    keywords: keywords || undefined,
  });
}

export function createRelationshipCategory(knowledgeGraphId, code, name) {
  return httpPost("/admin/relationshipCategory/v1/create", {
    knowledgeGraphId,
    code,
    name,
  });
}

export function updateRelationshipCategoryName(id, name) {
  return httpPost("/admin/relationshipCategory/v1/updateName", { id, name });
}

export function updateRelationshipCategoryCode(id, code) {
  return httpPost("/admin/relationshipCategory/v1/updateCode", { id, code });
}

export function deleteRelationshipCategory(id) {
  return httpPost("/admin/relationshipCategory/v1/delete", { id });
}
